import EnglishSentences from "../assets/Vocab/EnglishSentences.json";
import ChineseSentences from "../assets/Vocab/ChineseSentences.json";
import SomaliSentences from "../assets/Vocab/SomaliSentences.json";

const ENGLISH_SENTENCES = EnglishSentences;
const CHINESE_SENTENCES = ChineseSentences;
const SOMALI_SENTENCES = SomaliSentences;

export { ENGLISH_SENTENCES, SOMALI_SENTENCES, CHINESE_SENTENCES };
